import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../../models/organization.model';

@Pipe({
  name: 'productToSale'
})
export class ProductToSalePipe implements PipeTransform {

  transform(products: Product[]): Product[] {
    // TODO store in 2(Modifiers) as constant
    return products.filter(product => {
      return product.kind !== 2 && !(product.sizes.length === 1 && product.sizes[0].price === 0);
    });
  }

}
